import service from './axios'
import { useAppStore } from '@/stores/app'
import { checkSomethingIsOk } from '@/utils'

const clientApi = '/api'

export const getVerCode = async (): Promise<any> => {
  const app = useAppStore()

  await checkSomethingIsOk(() => !!app.fingerId)

  return service.get(clientApi + '/acc/verificationCode', {
    responseType: 'blob',
    headers: {
      'X-Fingerprint-ID': app.fingerId,
    }
  })
}

export const registerAccount = async (data: any): Promise<any> => {
  const app = useAppStore()

  await checkSomethingIsOk(() => !!app.fingerId)
  return service.post(clientApi + '/acc/register', data, {
    headers: {
      'X-Fingerprint-ID': app.fingerId,
    }
  })
}

export const loginAccount = async (data: any): Promise<any> => {
  const app = useAppStore()

  await checkSomethingIsOk(() => !!app.fingerId)
  return service.post(clientApi + '/acc/doLogin', data, {
    headers: {
      'X-Fingerprint-ID': app.fingerId,
    }
  })
}

export const logout = (): Promise<any> => {
  return service.get(clientApi + '/acc/logout')
}

export const modifyPwd = (data: any): Promise<any> => {
  return service.put(clientApi + '/acc/updatePassword', data)
}

export const getInfo = (): Promise<any> => {
  return service.get(clientApi + '/acc/findCurrentUserInfo')
}

export const getQrCode = (): Promise<any> => {
  return service.get(clientApi + '/acc/findAdminQRCode')
}
